import { getAppropriateApiUrl } from '@/sgwtConnect';
import type { ISGWTConnectConfiguration } from '@sgwt/connect-core';

export interface AppConfiguration {
  env: string;
  api_url: string;
  api_url_for_lan: string;
  fake_user: string;
  redirect_uri: string;
  piwik: {
    url: string;
    site_id: string;
  };
  sgconnect: ISGWTConnectConfiguration;
  signalR: {
    serverUrl: string;
    serverUrlForLan: string;
    hubName: string;
    reconnectDelay: number;
  };
  mailTemplateIds: {
    templateIdForTimeout: number;
    templateIdForTimeoutConfirmation: number;
    templateIdForAppcrashed: number;
    templateIdForAFWpredeliver: number;
  };
  sgConnectEnv: 'development' | 'homologation' | 'production'; // for widgets
}

export type Feature =
  | 'rollover'
  | 'predeliver'
  | 'americanForwardPredeliver'
  | 'alerts'
  | 'targetAccumulator'
  | 'forwardAccumulator'
  | 'squareTargetAccumulator'
  | 'pauseTargetAccumulator'
  | 'vanillaAccumulator';

export type IncomingFeatureToggle = `myFx${Capitalize<Feature>}`;

export const featureToggleMappings: Record<IncomingFeatureToggle, Feature> = {
  myFxAlerts: 'alerts',
  myFxPredeliver: 'predeliver',
  myFxAmericanForwardPredeliver: "americanForwardPredeliver",
  myFxRollover: 'rollover',
  myFxForwardAccumulator: 'forwardAccumulator',
  myFxTargetAccumulator: 'targetAccumulator',
  myFxSquareTargetAccumulator: 'squareTargetAccumulator',
  myFxPauseTargetAccumulator: 'pauseTargetAccumulator',
  myFxVanillaAccumulator: 'vanillaAccumulator',
};

declare global {
  interface Window {
    sgmeConfiguration: AppConfiguration;
    SGWTWidgetConfiguration: { environment: 'development' | 'homologation' | 'production'; bus: SgWidgetsBus };
  }
}

type SubscriptionHandle<T> = {
  topic: string;
  cb: BusEventCallback<T>;
};

type BusEventCallback<T> = (payload: T | undefined) => void;

export interface SgWidgetsBus {
  dangerouslyGetCurrentValue<T>(topicName: string): T | undefined;
  subscribe<T>(topicName: string, cb: BusEventCallback<T>): SubscriptionHandle<T>;
  unsubscribe<T>(handle: SubscriptionHandle<T>): void;
}

const appConfig = window.sgmeConfiguration;
export const isDev = appConfig?.env ? appConfig.env === 'local' || appConfig.env === 'devci' || appConfig.env === 'deve2e' : true;

export const isTest = appConfig?.env ? appConfig.env === 'test' : true;

export const getApiUrl = () => {
  if (window.location?.href?.includes('sgme-myfx.fr.world.socgen')) {
    return 'https://sgme-fx.fr.world.socgen/api/';
  }

  const apiUrl = getAppropriateApiUrl(window.sgmeConfiguration.api_url, window.sgmeConfiguration.api_url_for_lan)

  if (!apiUrl.endsWith('/')) {
    return `${apiUrl}/`;
  }
  return apiUrl;
};

